export enum ProductStatus {
  Inactive = 0,
  Active = 1
}


